import type { FirebaseApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import type { UserId } from "./types";

export default async function fileUpload(
  firebaseApp: FirebaseApp,
  file: File,
  userId: UserId,
): Promise<string> {
  console.debug("🔥 Firebase fileUpload", { file, userId });
  const storage = getStorage(firebaseApp);
  const fileRef = ref(storage, `${userId}/${file.name}`);
  const snapshot = await uploadBytes(fileRef, file);
  const downloadUrl = await getDownloadURL(snapshot.ref);
  return downloadUrl;
}
